export default __webpack_public_path__ + "static/media/Shadow's Gloves of the Tenth Court.9e7b6a29.jpg";